module.exports = "/_next/static/media/5d4e198cda62662da7e99577edd2e4ff.svg";